import * as React from 'react';
import { connect } from 'react-redux';

import { EnvironmentConfigurationProps } from 'common/environment/environment-configuration-props';
import { withEnvironmentConfiguration } from 'common/environment/with-environment-configuration';
import { State } from 'common/interfaces/state';
import { CompanySubscriptionModel } from '../../units/account/interfaces/company-subscription-model';
import { UserAbility } from './user-ability';

export interface AbilityContextValue {
  ability: UserAbility;

}

export const AbilityContext = React.createContext<AbilityContextValue>(null);

interface StateProps {
  userId: string | null;
  email: string | null;
  isAdmin: boolean;
  isOwner: boolean;
  userRoleName: string;
  subscription: CompanySubscriptionModel | null;
}

interface Props extends StateProps, EnvironmentConfigurationProps {

}


class AbilityContextProviderComponent extends React.Component<Props> {
  public render(): React.ReactNode {
    const { isAdmin, isOwner, subscription, userRoleName } = this.props;
    const ability = new UserAbility(isAdmin, isOwner, subscription, userRoleName);

    return (
      <AbilityContext.Provider value={{ ability }}>
        {this.props.children}
      </AbilityContext.Provider>
    );
  }
}

const mapStateToProps = (state: State): StateProps => {
  const subscriptionType = state.account.selectedSubscriptionType;
  const company = state.account && state.account.selectedCompany
    ? state.account.selectedCompany
    : null;
  const ownCompanyId = state.account.ownedCompany && state.account.ownedCompany.id;
  const subscription = company && company.subscriptions && company.subscriptions[subscriptionType];

  return {
    userId: state.account && state.account.id ? state.account.id : null,
    email: state.account && state.account.email ? state.account.email : null,
    isAdmin: state.account.isAdmin,
    isOwner: (company && company.id) === ownCompanyId,
    userRoleName: subscription?.userRoleName,
    subscription,
  };
};


export const AbilityContextProvider = withEnvironmentConfiguration(
  connect(mapStateToProps)(AbilityContextProviderComponent),
);
